import { inject, injectable } from 'inversify';
import {
  BannersPage,
  BannersRepositoryInterface,
} from '../domain/BannersRepositoryInterface';
import type { BannersServiceInterface } from 'features/banners/data/service/bannersService.types';
import BannersService from 'src/features/banners/data/service/bannersService';

@injectable()
class BannersRepository implements BannersRepositoryInterface {
  @inject(BannersService) private bannersService!: BannersServiceInterface;

  async getAll() {
    const response = await this.bannersService.getAll();
    return response.data as BannersPage;
  }
}

export default BannersRepository;
